import React from "react";
import useStore from "../../utils/store";

const Confirm2 = ({ open, setOpen, onClick }) => {
  const [confirm, setConfirm] = React.useState("");
  const user = useStore((state) => state.user);

  return (
    <div
      className="fixed z-10 inset-0 overflow-y-auto"
      aria-labelledby="modal-title"
      role="dialog"
      aria-modal="true"
    >
      <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
        <div
          className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
          aria-hidden="true"
        ></div>

        <span
          className="hidden sm:inline-block sm:align-middle sm:h-screen"
          aria-hidden="true"
        >
          &#8203;
        </span>

        <div className="inline-block align-bottom bg-secondary  text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full">
          <div className="bg-[#fff685] px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
            <div className="sm:flex sm:items-start">
              <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                <h3
                  className="text-lg leading-6 font-medium text-gray-900"
                  id="modal-title"
                >
                  Are you sure?
                </h3>
                <div className="mt-2">
                  <p className="text-sm text-black">
                    This is a permanent action. You cannot undo this action.
                  </p>
                </div>
                <div className="mt-4">
                  <p className="text-sm text-black">
                    Please enter your password to confirm.
                  </p>
                  <input
                    className="mt-3 bg-transparent border-2 border-black w-full p-2 text-black focus:outline-0"
                    type="password"
                    placeholder="Enter your password"
                    onChange={(e) => setConfirm(e.target.value)}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="bg-[#fff685] px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
            <button
              onClick={onClick}
              type="button"
              disabled={confirm !== user?.admin?.password}
              className="w-full disabled:bg-gray-300 disabled:text-black border-black inline-flex justify-center  border-2  shadow-sm px-4 py-2 bg-red-500 text-base font-medium text-white hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:ml-3 sm:w-auto sm:text-sm"
            >
              Reset
            </button>

            <button
              onClick={() => setOpen(false)}
              type="button"
              className="mt-3 w-full inline-flex justify-center  border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-secondary sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Confirm2;
